import {
	IconButton,
	ListItem,
	ListItemButton,
	ListItemText,
	Menu,
	Stack,
	Typography
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";


function WarbandSelect({ warbands, factionSlug }) {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const { factionSlug: subfaction } = useParams();
	const navigate = useNavigate();

	function handleOpen(event) {
		setAnchorEl(event.currentTarget);
	}

	const handleClose = () => {
		setAnchorEl(null);
	};

	function handleSelect(slug) {
		navigate(`../${slug}`);
		handleClose();
	}

	const options = [
		{ slug: factionSlug, name: "None" },
		...warbands,
	]

	const selection = options.find(o => o.slug === subfaction);

	return (
		<Stack direction="row" spacing={1} alignItems="center">
			{selection.name === "None" && (
				<Typography variant="body1" sx={{ opacity: 0.7 }}>
					Warband of Legend
				</Typography>
			)}
			{selection.name != "None" && (
				<Typography variant="body1" sx={{ opacity: 0.7 }}>
					{selection.name}
				</Typography>
			)}
			<IconButton variant="light" size="small" onClick={handleOpen}>
				<EditIcon fontSize="small" />
			</IconButton>
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				MenuListProps={{ disablePadding: true }}
			>
				<ListItem divider>
					<ListItemText
						primaryTypographyProps={{ variant: "h4", align: "center" }}
					>
						Warband of Legend
					</ListItemText>
				</ListItem>
				{options.map(o => (
					<ListItem
						key={o.slug}
						disablePadding
					>
						<ListItemButton onClick={handleSelect.bind(null, o.slug)}>
							{o.name}
						</ListItemButton>
					</ListItem>
				))}
			</Menu>
		</Stack>
	);
}


export default WarbandSelect;